import React, { useCallback, useEffect, useState } from 'react';
import service from '../../../services/usuarios';
import { datetime2Front } from '../../../utils/converts';
import Listagem from './Listagem';

const PendentesProcessamentoListagem = props => {

    const config = {
        columns: [
            { label: "Nome", field: "nome" },
            { label: "Bairro", field: "bairro" },
            { label: "Cidade", field: "cidade" },
            { label: "UF", field: "uf" },
            { label: "Data Cadastro", field: "createAt", convert: datetime2Front },
            { label: "Status", field: "status", convert: "statusCad"}
        ],
        pagination: {
            limit: 100
        },
        sort: '-createAt'
    }

    const [users, setUsers] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(true);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        params.push({field: "grupo", operator: "equal", value: "6025825722f01d0009a25b77"});
        params.push({field: "processado", operator: "equal", value: false});
        params.push({field: "recusado", operator: "equal", value: false});
        
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setUsers(result);
    }, [config.pagination.limit, config.sort]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    useEffect(() => {
        getList([], 0);
    }, [getList]);

    return (
        <>
            <Listagem registros={users} service={{ getList, upsert }} config={config} loadingList={loadingList} rota="pendentesProcessamento" />
        </>
    )
};

export default PendentesProcessamentoListagem;